import React from 'react';
import {
    Bolt,
    Delivereasy,
    Deliveroo,
    Delivery,
    Doordash,
    Easi,
    Glovo,
    Gojek,
    Grab,
    Grubhub,
    Jumia,
    Menulog,
    Mrdfood,
    Swiggy,
    UberEat,
    Custom,
} from '@menuzen/icon/build/outline';
import { Ninjaos } from '@menuzen/icon/build/solid';

export interface OrderOptionData {
    value: string;
    label: React.ReactElement;
    title?: string;
}
export const linksWithoutGuide = ['NINJAOS', 'CUSTOM'];
export const orderOptions: OrderOptionData[] = [
    ...[
        {
            value: 'UBEREATS',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <UberEat />
                    </div>
                    <p>Uber Eats</p>
                </div>
            ),
            title: 'Uber Eats',
        },
        {
            value: 'DOORDASH',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Doordash />
                    </div>
                    <p>DoorDash</p>
                </div>
            ),
            title: 'DoorDash',
        },
        {
            value: 'DELIVEROO',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Deliveroo />
                    </div>
                    <p>Deliveroo</p>
                </div>
            ),
        },
        {
            value: 'EASI',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Easi />
                    </div>
                    <p>EASI</p>
                </div>
            ),
            title: 'EASI',
        },
        {
            value: 'MENULOG',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Menulog />
                    </div>
                    <p>Menulog</p>
                </div>
            ),
        },
        {
            value: 'GOJEK',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Gojek />
                    </div>
                    <p>Gojek</p>
                </div>
            ),
        },
        {
            value: 'GRAB',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Grab />
                    </div>
                    <p>Grab</p>
                </div>
            ),
        },
        {
            value: 'GRUBHUB',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Grubhub />
                    </div>
                    <p>Grubhub</p>
                </div>
            ),
        },
        {
            value: 'DELIVERY',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Delivery />
                    </div>
                    <p>Delivery.com</p>
                </div>
            ),
            title: 'Delivery.com',
        },
        {
            value: 'JUMIA',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Jumia />
                    </div>
                    <p>Jumia Food</p>
                </div>
            ),
            title: 'Jumia Food',
        },
        {
            value: 'BOLT',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Bolt />
                    </div>
                    <p>Bolt Food</p>
                </div>
            ),
            title: 'Bolt Food',
        },
        {
            value: 'GLOVO',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Glovo />
                    </div>
                    <p>Glovo</p>
                </div>
            ),
        },
        {
            value: 'DELIVEREASY',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Delivereasy />
                    </div>
                    <p>Delivereasy</p>
                </div>
            ),
        },
        {
            value: 'MRDFOOD',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Mrdfood />
                    </div>
                    <p>MR D Food</p>
                </div>
            ),
            title: 'MR D Food',
        },
        {
            value: 'NINJAOS',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Ninjaos />
                    </div>
                    <p>NinjaOS</p>
                </div>
            ),
            title: 'NinjaOS',
        },
        {
            value: 'SWIGGY',
            label: (
                <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <div css={{ marginRight: '6px', fontSize: '20px' }}>
                        <Swiggy />
                    </div>
                    <p>Swiggy</p>
                </div>
            ),
        },
    ].sort((item1, item2) => {
        return item1.value.localeCompare(item2.value);
    }),
    {
        value: 'CUSTOM',
        label: (
            <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                <div css={{ marginRight: '6px', fontSize: '20px' }}>
                    <Custom />
                </div>
                <p>Custom</p>
            </div>
        ),
    },
];
